import { useQuery } from '@tanstack/react-query';
import { isAnyActivityInProgress } from '@/components/PartFinder/activityRows';
import { REPORT_POLL_INTERVAL_MS } from '@/hooks/useDataPolling/pollingConstants';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const RECENT_PART_FINDER_ACTIVITY_QUERY_KEY = 'partFinderActivity.recent';
export const RECENT_PART_FINDER_ACTIVITY_LIMIT = 5;

export function useGetRecentPartFinderActivity({ enabled = true }: { enabled?: boolean } = {}) {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [RECENT_PART_FINDER_ACTIVITY_QUERY_KEY, { tenantId }],
    queryFn: async () => api.tenants.listPartFinderActivity(tenantId, 1, RECENT_PART_FINDER_ACTIVITY_LIMIT),
    select: data => data.data.activity,
    enabled: !!tenantId && enabled,
    placeholderData: previousData => previousData,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    // Statuses have to stay live while a lookup runs, and the tile has no per-row polling of
    // its own: re-list until nothing in the feed is still working.
    refetchInterval: query =>
      isAnyActivityInProgress(query.state.data?.data.activity ?? []) ? REPORT_POLL_INTERVAL_MS : false,
  });
}
